export default {"src":"/newStatic/_next/static/media/star.75d2ce02.svg","height":28,"width":28};